import React from "react";
import { WizAuthority } from "@/containers/common";
import { framework_tool, component_tool } from '@/tool'
const { WizSpin, WizCard, WizEmpty, WizInput, WizRow, WizCol, WizTable, WizModal, WizBraftEditor } = component_tool;
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import { AuditForm } from './components'
const { ossFileUtils } = framework_tool

const getContentType = contentType => {
  switch (contentType) {
    case 1:
      return '文章';
    case 2:
      return '图片';
    case 3:
      return '视频'
    case 4:
      return '文档'
    case 5:
      return '下载文件'
  }
}

const getStatus = releaseState => {
  switch (releaseState) {
    case 0:
      return '草稿';
    case 1:
      return '已发布';
    case 2:
      return '取消发布'
    case 3:
      return '已关闭'
  }
}

const getPlatform = releasePlatform => {
  if (!releasePlatform) return
  const map = { '1': "PC", '2': 'APP', '3': '凯迪拉克IQ', '4': '小程序', '5': '雪佛兰企微', '6': '别克企微', '7': '凯迪拉克企微' }


  const textArr = releasePlatform.toString().split(',');
  const arr = [];
  for (let index = 0; index < textArr.length; index++) {
    arr.push(map[textArr[index]])
  }
  return arr.join(',').replace(/\,/g, ' ')
}

export default (record = {}, openLook = () => { }, openRichText = () => { }) => {
  let { changeData = {}, featured = {}, trainPath = {}, task = {}, contentList = [] } = record?.detailValue || {}
  const platformList = [
    { 0: 'PC' },
    { 1: 'APP' },
    { 2: '凯迪拉克IQ' },
    { 3: '雪佛兰企微' },
    { 4: '别克企微' },
    { 5: '凯迪拉克企微' },
  ]
  const positionsList = [
    { 0: '首页轮播' },
    { 1: '广告位' },
    { 2: '路径推荐位' },
  ]
  const formatList = (list, item) => {
    return list[item]
  }

  const columns = [
    {
      title: '排序',
      dataIndex: 'orderNum',
      key: 'orderNum',
      width: 60
    },
    {
      title: '类型',
      dataIndex: 'contentType',
      key: 'contentType',
      width: 60,
      render: (text) => text == 0 ? '课件' : '考试'
    },
    {
      title: '内容原名称',
      dataIndex: 'originalName',
      key: 'originalName',
      width: 120,
      ellipsis: true,
      // render: (text, record) => {
      //   return (<span onClick={() => openLook(record)}>{text}</span>
      //   )
      // }
    },
    {
      title: '课件编码',
      dataIndex: 'originalCode',
      key: 'originalCode',
      width: 100,
      // render: (text) => text == 0 ? '文件' : '文件地址'
    },
    {
      title: '是否更新',
      dataIndex: 'dataChange',
      key: 'dataChange',
      width: 100,
      render: (text) => text == 0 ? '否' : '是'
    },
    {
      title: '更新类型',
      dataIndex: 'changeType',
      key: 'changeType',
      width: 100,
      render: (text) => text == 2 ? '内容移除' : (text == 1 ? '内容更新' : (text == 3 ? '内容新增' : ''))
    },
    {
      title: '内容新名称',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      ellipsis: true,
    },
    {
      title: '更新后内容',
      dataIndex: 'name',
      key: 'name',
      width: 120,
      ellipsis: true,
      render: (text, record) => {
        return (<>
          {record.name ? <a onClick={() => openLook(record)}>查看</a> : null}
        </>
        )
      }
    },
  ];
  formatFinishTime = (date) => {
    let desc = ''
    let arr = []
    if (date) {
      arr = date.split('-')
      desc = arr[0] + '.' + arr[1]
    }
    return desc
  }
  formatDate = (date) => {
    let desc = ''
    let arr = []
    if (date) {
      arr = date.split(' ')
      desc = arr[0]
    }
    return desc
  }
  return [
    { label: '培训公司名称', value: record.trainCompanyName },
    { label: '申请人姓名', value: record.applicantFullName },
    { label: '申请人账号', value: record.applicantUserName },
    { label: '联系电话', value: record.telephone },
    { label: '课程名称', value: record.programName },
    { label: '品牌', value: record.brandCh },
    { label: '功能块', value: record.moduleCh },
    { label: '序号', value: record.orderNumber },
    { label: '版本号', value: record.versionNumber },
    { label: '开发/更新完成时间', value: formatFinishTime(record.programFinishDate) },
    { label: '课程编码', value: record.programScoId },
    { label: '课程时间', value: `${formatDate(record.startDate)} ~ ${formatDate(record.endDate)}` },
    { label: '课程分类', value: record.programCategoryNames },
    {
      label: '封面', value: <PhotoProvider
        toolbarRender={({ onScale, scale }) => {
          return (
            <>
              <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale + 1)} />
              <svg className="PhotoView-Slider__toolbarIcon" onClick={() => onScale(scale - 1)} />
            </>
          );
        }}>
        <div className="foo">
          <PhotoView key={'img_' + record.imgOne} src={getOssFilePath(record.imgOne)}>
            <a>查看</a>
          </PhotoView>
        </div>
      </PhotoProvider>
    },
    {
      label: '介绍', value: <a onClick={() => openRichText(record.intro)}>查看</a>,
      // { label: '介绍', value:<div id='knowledge_intro'> {_createIntro(record.intro)} </div>
    },
    { label: '受众', value: <WizAuthority value={record.authData} mode='Show' showBlock={false} /> },
    {
      label: '课件内容', value: <>
        <WizTable pagination={false} columns={columns} dataSource={contentList} />
      </>
    },
    { label: '更新说明', value: record.updateMark },
  ].filter(item => !!item)
}
